import { s as script, a as script$1 } from './DropdownItem-966537c6.js';
export { s as BDropdown, a as BDropdownItem } from './DropdownItem-966537c6.js';
import { u as use, a as registerComponent } from './plugins-9a909142.js';
import './trapFocus-3002f535.js';
import './config-86592f14.js';
import './helpers-8130329a.js';
import './typeof-92b42de1.js';
import 'vue';
import './ProviderParentMixin-edbbe118.js';
import './InjectedChildMixin-79185917.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, script);
    registerComponent(Vue, script$1);
  }
};
use(Plugin);

export { Plugin as default };
